<script lang="ts">
  import { buildSigil } from '../sigil';
  import { chipFor } from '../util';
  import { store } from '../store.svelte';
  import { visited } from '../visited.svelte';
  import { tilt } from '../actions';
  import { LAYER, type Entry } from '../data/grimoire';

  let { entry }: { entry: Entry } = $props();

  const chip = $derived(chipFor(entry));
  const sigil = $derived(buildSigil(entry));
  const layer = $derived(entry._reg === 'reg-1' ? LAYER[entry.id] : null);
  const visible = $derived(store.isVisible(entry.id));
  const seen = $derived(visited.has(entry.id));
</script>

<button
  class="node"
  class:tierC={entry.tier === 'C'}
  class:seen
  data-entry={entry.id}
  style:display={visible ? '' : 'none'}
  onclick={() => store.open(entry.id)}
  aria-label="{entry.nm}{seen ? ' (просмотрено)' : ''}"
  use:tilt
>
  <span class="node__sigil">{@html sigil}</span>
  <div class="node__name">{entry.nm}</div>
  <div class="node__essence">{entry.es}</div>
  <div class="node__tag">
    {#if layer}<span class="layer">{layer}</span>{/if}
    <span class="conf {chip.cls}">{chip.text}</span>
    {#if seen}<span class="node__seen" aria-hidden="true" title="просмотрено">·</span>{/if}
    <span class="node__more">раскрыть →</span>
  </div>
</button>
